document.addEventListener('DOMContentLoaded', function() {
  // Handle editable rating clicks
  document.addEventListener('click', function(e) {
    if (e.target.classList.contains('editable-rating')) {
      const ratingSpan = e.target;
      const assetId = ratingSpan.dataset.assetId;
      const currentRating = ratingSpan.dataset.currentRating || '';
      
      // Create input field
      const input = document.createElement('input');
      input.type = 'text';
      input.value = currentRating === 'Not Rated' ? '' : currentRating;
      input.className = 'form-control form-control-sm';
      input.style.width = '80px';
      input.style.display = 'inline-block';
      input.placeholder = 'Rating';
      
      // Create save button
      const saveBtn = document.createElement('button');
      saveBtn.innerHTML = '<i class="bi bi-check"></i>';
      saveBtn.className = 'btn btn-sm btn-success ms-1';
      saveBtn.type = 'button';
      
      // Create cancel button
      const cancelBtn = document.createElement('button');
      cancelBtn.innerHTML = '<i class="bi bi-x"></i>';
      cancelBtn.className = 'btn btn-sm btn-secondary ms-1';
      cancelBtn.type = 'button';
      
      // Store original content
      const originalContent = ratingSpan.innerHTML;
      
      // Replace content with input and buttons
      ratingSpan.innerHTML = '';
      ratingSpan.appendChild(input);
      ratingSpan.appendChild(saveBtn);
      ratingSpan.appendChild(cancelBtn);
      
      // Focus input
      input.focus();
      input.select();
      
      // Save function
      function saveRating() {
        const newRating = input.value.trim();
        
        fetch(`/assets/${assetId}/update_rating`, {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
          },
          body: JSON.stringify({ rating: newRating })
        })
        .then(response => response.json())
        .then(data => {
          if (data.success) {
            // Update the display
            const displayRating = newRating || 'Not Rated';
            ratingSpan.textContent = displayRating;
            ratingSpan.dataset.currentRating = newRating;
            
            // Update CSS class on parent span
            const parentSpan = ratingSpan.closest('span');
            if (parentSpan) {
              // Remove old rating classes
              parentSpan.className = parentSpan.className.replace(/text-(success|info|primary|warning|danger|muted)/g, '');
              
              // Add new rating class
              const ratingClass = getRatingCssClass(newRating);
              if (ratingClass) {
                parentSpan.classList.add(ratingClass);
              }
            }
            
            // Update investment grade badges
            updateInvestmentGradeBadges(ratingSpan, newRating);
            
            // Update the sortable table key if present
            const tableCell = ratingSpan.closest('td');
            if (tableCell) {
              const sortKey = getRatingSortOrder(newRating);
              tableCell.setAttribute('sorttable_customkey', sortKey);
            }
          } else {
            alert('Error updating rating: ' + (data.message || 'Unknown error'));
            ratingSpan.innerHTML = originalContent;
          }
        })
        .catch(error => {
          console.error('Error:', error);
          alert('Error updating rating');
          ratingSpan.innerHTML = originalContent;
        });
      }
      
      // Cancel function
      function cancelEdit() {
        ratingSpan.innerHTML = originalContent;
      }
      
      // Event listeners
      saveBtn.addEventListener('click', saveRating);
      cancelBtn.addEventListener('click', cancelEdit);
      
      // Save on Enter, cancel on Escape
      input.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          saveRating();
        } else if (e.key === 'Escape') {
          e.preventDefault();
          cancelEdit();
        }
      });
      
      // Cancel if clicking outside
      input.addEventListener('blur', function() {
        setTimeout(cancelEdit, 200); // Delay to allow button clicks
      });
      
      // Prevent blur when clicking buttons
      saveBtn.addEventListener('mousedown', function(e) {
        e.preventDefault();
      });
      cancelBtn.addEventListener('mousedown', function(e) {
        e.preventDefault();
      });
    }
  });
});

// Helper function to get CSS class for rating
function getRatingCssClass(rating) {
  if (!rating) return 'text-muted';
  
  switch (rating.toUpperCase()) {
    case 'AAA':
      return 'text-success';
    case 'AA1':
    case 'AA2':
    case 'AA3':
      return 'text-success';
    case 'A1':
    case 'A2':
    case 'A3':
      return 'text-info';
    case 'BAA1':
    case 'BAA2':
    case 'BAA3':
      return 'text-primary';
    case 'BA1':
    case 'BA2':
    case 'BA3':
    case 'B1':
    case 'B2':
    case 'B3':
      return 'text-warning';
    case 'CAA1':
    case 'CAA2':
    case 'CAA3':
    case 'CA':
    case 'C':
      return 'text-danger';
    default:
      return 'text-muted';
  }
}

// Helper function to check if rating is investment grade
function isInvestmentGrade(rating) {
  if (!rating) return false;
  const investmentGradeRatings = ['AAA', 'AA1', 'AA2', 'AA3', 'A1', 'A2', 'A3', 'BAA1', 'BAA2', 'BAA3'];
  return investmentGradeRatings.includes(rating.toUpperCase());
}

// Helper function to get rating sort order
function getRatingSortOrder(rating) {
  const ratingOrder = {
    "AAA": 1, 
    "AA1": 2, "AA2": 3, "AA3": 4,
    "A1": 5, "A2": 6, "A3": 7,
    "BAA1": 8, "BAA2": 9, "BAA3": 10,
    "BA1": 11, "BA2": 12, "BA3": 13,
    "B1": 14, "B2": 15, "B3": 16,
    "CAA1": 17, "CAA2": 18, "CAA3": 19,
    "CA": 20, "C": 21,
    "NOT RATED": 99
  };
  return ratingOrder[rating?.toUpperCase()] || 50;
}

// Helper function to update investment grade badges
function updateInvestmentGradeBadges(ratingSpan, newRating) {
  const tableCell = ratingSpan.closest('td');
  if (!tableCell) return;
  
  // Remove existing badges
  const existingBadges = tableCell.querySelectorAll('.badge');
  existingBadges.forEach(badge => badge.remove());
  
  // Add new badges based on rating
  if (isInvestmentGrade(newRating)) {
    const igBadge = document.createElement('span');
    igBadge.className = 'badge bg-success ms-1';
    igBadge.textContent = 'IG';
    tableCell.appendChild(igBadge);
  } else if (newRating && newRating !== "Not Rated" && newRating.trim() !== '') {
    const hyBadge = document.createElement('span');
    hyBadge.className = 'badge bg-warning ms-1';
    hyBadge.textContent = 'HY';
    tableCell.appendChild(hyBadge);
  }
} 